import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeActionTypeDownloadFilesList} from './doppe-action-type-download-files-list';

export const doppeActionTypeDownloadFilesListViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeDownloadFilesList, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeDownloadFilesListWidget: (await import('./doppe-action-type-download-files-list-widget/doppe-action-type-download-files-list-widget')).DoppeActionTypeDownloadFilesListWidget,
        };
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeDownloadFilesListWidget,
        } = viewerComponents;

        return (
            <DoppeActionTypeDownloadFilesListWidget
                {...renderProps}
            />
        );

    },
});
